<template>
	<div>
		<v-container id="user-profile" fluid tag="section">
			<v-row justify="center">
				<v-col cols="12" :md="mdtable">
					<v-card v-if="this.menu != 'Upload Image'" height="100%">
						<v-simple-table>
							<template v-slot:top>
								<v-toolbar flat color="white">
									<v-toolbar-title>Booth Listing</v-toolbar-title>
									<v-divider class="mx-4" inset vertical></v-divider>
									<v-spacer></v-spacer>
									<v-btn color="primary" dark class="mb-2" @click="addBooth()">Add</v-btn>
								</v-toolbar>
								<v-toolbar flat>
									<v-col :sm="sm">
										<v-select :items="filterStatusOption" @change="listBooth" v-model="filterStatus" label="Status" class="sort" outlined dense></v-select>
									</v-col>
									<v-col :sm="sm">
										<v-select :items="sortOption" @change="sortBooth" v-model="sortBy" label="Sort By" class="sort" outlined dense></v-select>
									</v-col>
									<v-col :sm="sm">
										<v-select :items="sortDirOption" @change="sortBooth" v-model="sortDir" class="sort" v-if="sortBy != 'None'" outlined dense></v-select>
									</v-col>
									<v-spacer></v-spacer>
									<v-col :sm="sm">
										<v-select :items="rowsPerPage" @change="changeTotalRows" v-model="totalRows" hint="Rows" label="Display Item" class="sort" outlined dense></v-select>
									</v-col>
								</v-toolbar>
							</template>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Booth</th>
										<th class="text-left">Booth Name</th>
										<th class="text-left">Submission</th>
										<th class="text-left">Status</th>
										<th class="text-left">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, idxItem) in boothList" :key="idxItem">
										<td>
											{{ item.id }}
											<v-icon @click="up(item)" small>mdi-arrow-up</v-icon>
											<v-icon @click="down(item)" small>mdi-arrow-down</v-icon>
										</td>
										<td>{{ item.name }}</td>
										<td>
											<v-tooltip v-if="item.dataMap.submitted" bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on" color="success">mdi-text-box-check-outline</v-icon>
												</template>
												<span>{{ item.dataMap.submitted }}</span>
											</v-tooltip>
											<v-icon v-else>mdi-text-box-remove-outline</v-icon>
										</td>
										<td>{{ item.status ? "Active" : "Inactive" }}</td>
										<td>
											<v-icon @click="edit(item, 'Booth Settings')" small class="mr-2" color="blue" title="Booth Settings">mdi-pencil</v-icon>
											<v-icon small class="mr-2" color="blue" @click="edit(item, 'Booth Rep')" title="Booth Rep">mdi-account-multiple</v-icon>
											<v-icon small class="mr-2" color="blue" @click="edit(item, 'External Links')" title="Navigation Buttons">mdi-format-list-bulleted</v-icon>
											<v-icon small class="mr-2" color="blue" @click="edit(item, 'Settings')" title="Settings">mdi-cog</v-icon>
											<v-icon small class="mr-2" color="blue" @click="edit(item, 'Document')" title="Documents/Videos">mdi-file</v-icon>
											<v-icon small class="mr-2" color="blue" @click="edit(item, 'Upload Image')" title="Upload Image">mdi-panorama</v-icon>
											<v-icon @click="copyLink(item)" small class="mr-2" color="blue" title="Copy Link">mdi-content-copy</v-icon>
											<v-icon
												small
												color="blue"
												@click="
													showDeleteDialog(item);
													isDeleteBooth = true;
												"
												>mdi-delete</v-icon
											>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
						<v-pagination v-model="pagination.page" :length="pagination.total" :total-visible="pagination.total" @input="onPageChange()"></v-pagination>
					</v-card>

					<v-dialog v-model="isAddBooth" max-width="500px">
						<v-card>
							<v-card-title>
								<span class="headline">Add Booth</span>
							</v-card-title>

							<v-card-text>
								<v-text-field v-model="entity.name" label="Booth name"></v-text-field>
								<div class="d-flex justify-end">
									<v-btn color="blue darken-1" text @click="isAddBooth = false">Close</v-btn>
									<v-btn color="blue darken-1" text @click="save()">Save</v-btn>
								</div>
							</v-card-text>
						</v-card>
					</v-dialog>
				</v-col>

				<v-col cols="12" :md="mdform" v-if="isShowForm">
					<v-card v-if="menu == 'Booth Settings'">
						<v-form ref="formEditBooth" v-model="valid" @submit.prevent="update">
							<v-icon title="close" @click="close()" style="float: right">mdi-close</v-icon>
							<v-card-title>
								<span>{{ menu }}</span>
							</v-card-title>
							<v-col>
								<v-switch v-model="entity.status" :label="entity.status ? 'Active' : 'Inactive'"></v-switch>
								<v-text-field class="input" v-model="entity.name" label="Booth Name" outlined></v-text-field>
								<p>Company Profile</p>
								<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="$root.initTinyMceEditor()" v-model="entity.description" style="background-color: #eee"></editor>
								<v-switch v-model="logoType" :label="'Logo type : ' + (logoType ? 'URL' : 'Upload')"></v-switch>
								<v-col cols="12" v-if="logoType">
									<v-text-field v-model="entity.logo" prepend-icon="mdi-image" label="Logo" placeholder="From Url" hint="A 200x200 pixels image size is highly recommended"></v-text-field>
								</v-col>
								<v-col cols="12" v-else>
									<v-file-input v-model="attachment" label="Logo" accept="image/png, image/jpeg, image/jpg" placeholder="Upload" prepend-icon="mdi-image" :show-size="1000" hint="A 200x200 pixels image size is highly recommended">
										<template v-slot:selection="{ text }" :default="entity.logo">
											<v-chip color="primary" dark label small>{{ text }}</v-chip>
										</template>
									</v-file-input>
								</v-col>
								<v-select :items="structureList" label="Back to floor" outlined v-model="entity.dataMap.floor" item-text="name" item-value="slug"></v-select>
								<h3>Point of Contact :</h3>
								<p>(This information is used to reach out to exhibitors to get their Booth setup)</p>
								<v-text-field class="input" v-model="entity.contactName" label="Contact Name" outlined></v-text-field>
								<v-text-field class="input" v-model="entity.contactEmail" label="Contact Email" outlined></v-text-field>
								<v-switch v-model="entity.dataMap.noChatBooth" :label="'Turn Off Chat: ' + (entity.dataMap.noChatBooth ? 'True' : 'False')"></v-switch>
								<v-col>
									<v-select
										v-model="entity.allowTicketList"
										:items="ticketList"
										item-text="name"
										item-value="id"
										label="Allowed Ticket List"
										prepend-icon="mdi-check"
										multiple
										chips
										hint="Empty list means all access"
										persistent-hint
									></v-select>
								</v-col>
								<v-col>
									<v-select v-model="entity.denyTicketList" :items="ticketList" item-text="name" item-value="id" label="Denied Ticket List" prepend-icon="mdi-block-helper" multiple chips></v-select>
								</v-col>

								<h2>Add booth interests</h2>

								<div style="max-height:200px; overflow: auto;" v-if="showAddInterests == false">
									<v-chip class="primary" v-for="item in entity.interestNameList" :key="item" :value="item" style="margin-right: 5px">{{item}}</v-chip>
								</div>

								<v-col v-if="showAddInterests == false">
									<v-btn @click="listInterest(); showAddInterests = true" class="primary px-8" rounded>Add Interests</v-btn>
								</v-col>

								<v-col v-if="showAddInterests == true">
									<div style="max-height:200px; overflow: auto;">
										<v-chip-group v-model="entity.interestList" active-class="primary" column multiple>
											<v-chip v-for="item in interestList" :key="item.id" :value="item.id">{{item.name}}</v-chip>
										</v-chip-group>
									</div>
								</v-col>

								<div class="d-flex justify-end">
									<v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-col>
						</v-form>
					</v-card>

					<v-card height="100%" v-if="menu == 'Booth Rep' && !isShowAddBoothRep">
						<v-simple-table>
							<template v-slot:top>
								<v-icon title="close" @click="close()" style="float: right">mdi-close</v-icon>
								<v-toolbar flat color="white">
									<v-toolbar-title>Booth Rep</v-toolbar-title>
									<v-divider class="mx-4" inset vertical></v-divider>
									<v-toolbar-title>{{ entity.name }}</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-btn v-if="entity.boothFeatureLimitList[3].limit == null" color="primary" dark class="mb-2" @click="addBoothRep()">Add</v-btn>
									<v-btn v-else-if="boothRepList.length < entity.boothFeatureLimitList[3].limit" color="primary" dark class="mb-2" @click="addBoothRep()">Add</v-btn>
								</v-toolbar>
							</template>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">First Name</th>
										<th class="text-left">Last Name</th>
										<th class="text-left">Email</th>
										<th class="text-left">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, idxItem) in boothRepList" :key="idxItem">
										<td>{{ item.firstName }}</td>
										<td>{{ item.lastName }}</td>
										<td>{{ item.email }}</td>
										<td>
											<v-icon small class="mr-2" title="Edit" @click="editBoothRep(item)">mdi-pencil</v-icon>
											<v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>

					<v-card v-if="menu == 'Booth Rep' && isShowAddBoothRep">
						<v-icon title="close" @click="closeBoothRep()" style="float: right">mdi-close</v-icon>
						<v-card-title>
							<span>{{ menu }}</span>
							<v-divider class="mx-4" inset vertical></v-divider>
							<span>{{ entity.name }}</span>
						</v-card-title>
						<v-card-text>
							<v-form v-model="valid" ref="formBoothRep" @submit.prevent="updateBoothRep">
								<div v-if="isEditBoothRep">
									Current Booth Rep:
									<br />
									<span>
										{{ experienceUser.email }}
										<br />
									</span>
								</div>

								<v-text-field v-model="boothRep.dataMap.availability" label="Availability" hint="Example : Friday 9am - 5pm est" persistent-hint v-if="isEditBoothRep" style="margin-top: 15px"></v-text-field>

								<v-textarea v-if="!isEditBoothRep" v-model="keyword" label="Input booth rep email and availability list (separated by new line)" @input="checkLimitForBoothRep" required></v-textarea>
								<div class="d-flex justify-end">
									<v-btn color="blue darken-1" text @click="closeBoothRep()">Cancel</v-btn>
									<v-btn :disabled="!valid" color="blue darken-1" type="submit">Save</v-btn>
								</div>
							</v-form>
						</v-card-text>
					</v-card>

					<v-card height="100%" class="scroll" v-if="menu == 'External Links' && !isShowAddLink && !isShowEditLink">
						<v-simple-table>
							<template v-slot:top>
								<v-icon title="close" @click="close()" style="float: right">mdi-close</v-icon>
								<v-toolbar flat color="white">
									<v-toolbar-title>External Links</v-toolbar-title>
									<v-divider class="mx-4" inset vertical></v-divider>
									<v-toolbar-title>{{ entity.name }}</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-btn v-if="entity.boothFeatureLimitList[0].limit == null" color="primary" dark class="mb-2" @click="addExternalLink()">Add</v-btn>
									<v-btn v-else-if="entity.menuLinkList.length < entity.boothFeatureLimitList[0].limit" color="primary" dark class="mb-2" @click="addExternalLink()">Add</v-btn>
								</v-toolbar>
							</template>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Link Title</th>
										<th class="text-left">Status</th>
										<th class="text-left">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, idxItem) in entity.menuLinkList" :key="idxItem">
										<td>{{ item.title }}</td>
										<td>{{ item.status ? "Active" : "Inactive" }}</td>
										<td>
											<v-icon small class="mr-2" title="External Links" @click="editExternalLink(item)">mdi-pencil</v-icon>
											<v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>

						<v-simple-table v-if="menu == 'External Links'">
							<template v-slot:top>
								<v-toolbar flat color="white">
									<v-toolbar-title>Booth Features</v-toolbar-title>
									<v-divider class="mx-4" inset vertical></v-divider>
									<v-spacer></v-spacer>
									<v-btn color="primary" dark class="mb-2" @click="update()" v-if="showSaveFeature">Save</v-btn>
								</v-toolbar>
							</template>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Link Title</th>
										<th class="text-left">Status</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, idxItem) in entity.boothFeatureList" :key="idxItem">
										<td v-if="item.tabTitle != 'Products'">{{ item.tabTitle }}</td>
										<td v-if="item.tabTitle != 'Products'" style="display: flex; flex-direction: row">
											<v-switch v-model="item.status" v-on:change="changeFeatureStatus(item)" :label="item.status ? 'Active' : 'Inactive'"></v-switch>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>

					<v-card v-if="menu == 'Settings'" height="100%">
						<v-simple-table>
							<template v-slot:top>
								<v-icon title="close" @click="close()" style="float: right">mdi-close</v-icon>
								<v-toolbar flat color="white">
									<v-toolbar-title>Settings</v-toolbar-title>
									<v-divider class="mx-4" inset vertical></v-divider>
									<v-toolbar-title>{{ entity.name }}</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-btn color="primary" dark class="mb-2" @click="update()" v-if="showSaveFeatureLimit">Save</v-btn>
								</v-toolbar>
							</template>
							<template v-slot:default>
								<v-card-text v-for="(item, idxItem) in entity.boothFeatureLimitList" :key="idxItem" style="padding: 0px 20px">
									<v-text-field
										v-if="item.tabTitle == 'Documents' || item.tabTitle == 'Videos' || item.tabTitle == 'Links' || item.tabTitle == 'Booth Reps'"
										v-on:change="changeFeatureLimit(item)"
										@change="numberChecking(item)"
										:prepend-icon="item.icon"
										:label="item.tabTitle + ' Limit'"
										v-model="item.limit"
									>
									</v-text-field>
								</v-card-text>
								<v-autocomplete
									style="padding: 10px 20px 20px 20px"
									v-on:change="changeTag()"
									prepend-icon="mdi-tag"
									label="Booth Design Tag"
									v-model="entity.boothDesignTagList"
									:items="layoutTagList"
									clearable
									multiple
									chips
									small-chips
								>
								</v-autocomplete>
							</template>
						</v-simple-table>
					</v-card>

					<v-card v-if="menu == 'Document' && !isAddDocument" height="100%">
						<v-simple-table>
							<template v-slot:top>
								<v-icon title="close" @click="close()" style="float: right">mdi-close</v-icon>
								<v-toolbar flat color="white">
									<v-toolbar-title>Documents/Videos</v-toolbar-title>
									<v-divider class="mx-4" inset vertical></v-divider>
									<v-toolbar-title>{{ entity.name }}</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-btn color="primary" dark class="mb-2" @click="addDocument()" v-if="showAddBtnDoc">Add</v-btn>
								</v-toolbar>
							</template>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Id</th>
										<th class="text-left">Title</th>
										<th class="text-left">Type</th>
										<th class="text-left">Status</th>
										<th class="text-left">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, idxItem) in documentList" :key="idxItem">
										<td>{{ item.id }}</td>
										<td>{{ item.title }}</td>
										<td>{{ item.type }}</td>
										<td>{{ item.status ? "Active" : "Inactive" }}</td>
										<td>
											<v-icon medium class="mr-2" title="Edit" @click="editDocument(item)">mdi-pencil</v-icon>
											<v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>

					<v-card v-if="menu == 'Document' && isAddDocument">
						<v-form ref="formEdit" v-model="valid" @submit.prevent="updateDocument">
							<v-card-title>
								<span class="headline">Documents/Videos</span>
							</v-card-title>

							<v-card-text>
								<v-switch v-model="document.status" :label="document.status ? 'Active' : 'Inactive'"></v-switch>
								<v-select v-model="document.type" :items="documentTypes" label="Content Type" :rules="[(v) => !!v || 'Type is required', (v) => v != 'Select a Type']" required></v-select>
								<v-text-field v-model="document.title" label="Title" :rules="[(v) => !!v || 'Title is required']" required></v-text-field>
								<v-switch v-model="document.dataMap.docType" :label="'Type : ' + (document.dataMap.docType ? 'URL' : 'Upload')"></v-switch>
								<v-col cols="12" v-if="document.dataMap.docType">
									<v-text-field v-model="document.value" prepend-icon="mdi-image" label="Content Url" placeholder="From Url"></v-text-field>
								</v-col>
								<v-col cols="12" v-else>
									<v-file-input v-model="attachment1" label placeholder="Drop files here to upload" prepend-icon="mdi-attachment" :show-size="1000" :messages="'Current : ' + document.value" accept="application/pdf, video/mp4">
										<template v-slot:selection="{ text }" :default="document.value">
											<v-chip color="primary" dark label small>{{ text }}</v-chip>
										</template>
									</v-file-input>
								</v-col>
								<p>Open Link in</p>
								<v-radio-group v-model="document.dataMap.openLinkOption">
									<v-radio label="New Tab" value="1"></v-radio>
									<v-radio label="Dialog" value="2"></v-radio>
								</v-radio-group>
								<div class="d-flex justify-end">
									<v-btn color="blue darken-1" text @click="cancelAddDocument()">Cancel</v-btn>
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-card-text>
						</v-form>
					</v-card>

					<v-card v-if="menu == 'Upload Image'" height="100%">
						<v-icon
							title="close"
							@click="
								editBannerUrl = false;
								closeUploadImage();
							"
							style="float: right"
							>mdi-close</v-icon
						>
						<v-card-title>
							<span>{{ menu }}</span>
							<v-divider class="mx-4" inset vertical></v-divider>
							<span>{{ entity.name }}</span>
						</v-card-title>
						<v-card-text>
							<v-card elevation="0">
								<v-card-text>
									<span>
										The booth graphic is the first thing attendees see when they open your booth. So we'll need to make it look nice and also representative of your brand. Our graphic designers can do most of the heavy lifting
										required, but we still need some information from you first.
									</span>
								</v-card-text>
							</v-card>
							<v-card elevation="0">
								<v-card-text>
									<div v-if="!showLibrary">
										<v-btn color="primary" @click="showLibrary = true">Change Your Booth Template</v-btn>
										<v-btn color="primary" @click="livePreview = true" style="margin-left: 10px">Preview Live Version</v-btn>
										<h2 style="margin-top: 20px">Selected Template :</h2>
										<v-img :src="$root.asset(selectedLayoutImage)" eager></v-img>
									</div>
									<div v-else>
										<span>
											<b style="font-size: 16px; color: blue">Select your booth template</b>
											<br />We've got several different templates to choose from. All templates have placeholder areas where you can put in your own images/text/videos.
										</span>
										<v-row>
											<v-col cols="8">
												<v-autocomplete v-model="layoutTagFilter" :items="layoutTagListFilter" chips small-chips deletable-chips label="Filter by tags" multiple solo dense></v-autocomplete>
											</v-col>
											<div style="display: flex; flex-direction: row; margin-top: 13px">
												<v-btn style="margin-right: 10px" @click="filterLayout(false)" color="primary">filter</v-btn>
												<v-btn @click="resetLayout" color="primary">Reset</v-btn>
											</div>
										</v-row>
										<v-carousel hide-delimiters>
											<v-carousel-item v-for="(item, i) in layoutList" :key="i" eager>
												<v-img :src="$root.asset(item.dataMap.value)" height="100%" contain eager>
													<v-btn v-if="item.id == selectedLayoutId" color="blue">Selected Template</v-btn>
													<v-btn v-else @click="selectBoothTemplate(item)">Select This Template</v-btn>
												</v-img>
											</v-carousel-item>
										</v-carousel>
										<div class="d-flex justify-end top">
											<v-btn color="primary" v-if="selectedLayoutId != null" @click="showLibrary = false">Cancel</v-btn>
										</div>
									</div>
								</v-card-text>
							</v-card>

							<v-card v-if="selectedLayoutId" elevation="0">
								<v-card-title>Graphics for the Banner Placeholders</v-card-title>
								<v-card-text>
									<span v-for="(item, idxItem) in bannerDataList" :key="idxItem">
										<h2>{{ item.name }}</h2>
										<v-row>
											<v-col cols="12" md="2">
												<p>Current Banner Image : {{ item.image }}</p>
												<p>Banner Image Type :</p>
												<v-radio-group v-model="item.bannerImageType" mandatory>
													<v-radio label="Stretch" value="100% 100%"></v-radio>
													<v-radio label="Cover" value="cover"></v-radio>
													<v-radio label="Contain" value="contain"></v-radio>
												</v-radio-group>
											</v-col>
											<v-col cols="1" style="margin-top: 10px">
												<v-switch v-model="item.imageType" :label="'Image Type : ' + (item.imageType ? 'URL' : 'Upload')"></v-switch>
											</v-col>
											<v-col cols="12" md="2">
												<v-btn
													v-if="!item.imageType"
													style="margin-top: 20px"
													@click="
														openUpload('bannerImage', item);
														isUpload = true;
													"
													>Upload</v-btn
												>
												<v-text-field v-else v-model="item.image" label="Url"></v-text-field>
												<br />
											</v-col>
											<v-col cols="12" md="2">
												<p>Current Banner Value : {{ item.url }}</p>
											</v-col>
											<v-col cols="12" md="1" style="margin-top: 10px">
												<v-switch v-model="item.bannerType" :label="'Value Type : ' + (item.bannerType ? 'URL' : 'Upload')"></v-switch>
											</v-col>
											<v-col cols="12" md="2">
												<v-btn
													v-if="!item.bannerType"
													style="margin-top: 20px"
													@click="
														openUpload('bannerUrl', item);
														isUpload = true;
													"
													>Upload</v-btn
												>
												<v-text-field v-else v-model="item.url" label="Url"></v-text-field>
											</v-col>
											<v-col cols="12" md="2">
												<p>Open Link in</p>
												<v-radio-group v-model="item.openLinkOption">
													<v-radio label="New Tab" value="1"></v-radio>
													<v-radio label="Dialog" value="2"></v-radio>
													<v-radio label="Current Tab" value="3"></v-radio>
												</v-radio-group>
											</v-col>
										</v-row>
										<hr class="horizontal-line" />
									</span>
								</v-card-text>
							</v-card>
							<div class="d-flex justify-end top">
								<v-btn @click="closeUploadImage()">Close</v-btn>
								<v-btn color="primary" dark class="mb-2" @click="saveLayout()">Save</v-btn>
							</div>
						</v-card-text>
					</v-card>

					<v-dialog v-if="livePreview" v-model="livePreview" scrollable fullscreen>
						<v-card elevation="0">
							<v-card-title class="headline">
								Preview Live Version
								<v-spacer></v-spacer>
								<v-btn icon @click="livePreview = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<div style="display: inline-block; position: relative; min-width: 100%; overflow-x: auto" class="booth-img">
									<img style="width: auto; min-width:100%;right: 0, bottom:0;" :style="$vuetify.breakpoint.smAndDown ? 'height: 100vmax;' : 'height: calc(100vmax * (9/16));'" title :src="$root.asset(selectedLayoutImage)" />
									<div v-if="bannerDataList">
										<div v-for="(banner, idxBanner) in bannerDataList" :key="idxBanner">
											<div v-if="banner.coordinateList" class="banner-place">
												<video
													v-if="banner.image && banner.image.endsWith('.mp4')"
													id="video"
													:style="{
														zIndex: 1,
														left: banner.coordinateList[0] + '%',
														top: banner.coordinateList[1] + '%',
														transform: banner.skewX ? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)' : 'skew(0deg, 0deg)',
														width: banner.coordinateList[2] + '%',
														height: banner.coordinateList[3] + '%',
														position: 'absolute'
													}"
													preload="auto"
													autoplay="autoplay"
													muted
													playsinline
													disablepictureinpicture
													loop="loop"
												>
													<source :src="$root.asset(banner.image)" type="video/mp4" />
												</video>
												<img
													v-if="banner.image && !banner.image.endsWith('.mp4')"
													:style="{
														zIndex: 1,
														left: banner.coordinateList[0] + '%',
														top: banner.coordinateList[1] + '%',
														transform: banner.skewX ? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)' : 'skew(0deg, 0deg)',
														width: banner.coordinateList[2] + '%',
														height: banner.coordinateList[3] + '%',
														position: 'absolute',
														objectFit: banner.bannerImageType,
														backgroundColor: 'white'
													}"
													title
													:src="$root.asset(banner.image)"
												/>
												<a
													v-if="banner.url"
													:style="{
														zIndex: 2,
														left: banner.coordinateList[0] + '%',
														top: banner.coordinateList[1] + '%',
														transform: banner.skewX ? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)' : 'skew(0deg, 0deg)',
														width: banner.coordinateList[2] + '%',
														height: banner.coordinateList[3] + '%',
														position: 'absolute'
													}"
												></a>
											</div>
										</div>
									</div>
								</div>
							</v-card-text>
						</v-card>
					</v-dialog>

					<v-card height="100%" v-if="menu == 'Product'">
						<v-simple-table>
							<template v-slot:top>
								<v-icon title="close" @click="close()" style="float: right">mdi-close</v-icon>
								<v-toolbar flat color="white">
									<v-toolbar-title>Product</v-toolbar-title>
									<v-divider class="mx-4" inset vertical></v-divider>
									<v-toolbar-title>{{ entity.name }}</v-toolbar-title>
									<v-spacer></v-spacer>
								</v-toolbar>
								<v-btn class="mx-4" color="primary" @click="isAddProduct = !isAddProduct">Import</v-btn>
								<v-btn class="mx-4" color="primary" @click="download('/system/booth/product/download/data')">Export</v-btn>
								<v-btn class="mx-4" color="primary" @click="download('/system/booth/product/download/template')">Template</v-btn>
							</template>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Title</th>
										<th class="text-left">Price($)</th>
										<th class="text-left">Sku</th>
										<th class="text-left">Product Category</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, idxItem) in productList" :key="idxItem">
										<td>{{ item.title }}</td>
										<td>{{ item.price }}</td>
										<td>{{ item.sku }}</td>
										<td>{{ item.productCategory }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>

					<v-dialog v-model="isAddProduct" persistent max-width="500px" transition="dialog-bottom-transition">
						<v-card tile>
							<v-card-title class="headline">
								Upload
								<v-spacer></v-spacer>
								<v-btn icon @click="isAddProduct = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-divider class="mx-4"></v-divider>
							<v-card-text>
								<v-form ref="formProduct" v-model="valid" @submit.prevent="uploadProduct">
									<v-row class="d-flex justify-center align-center">
										<v-col cols="12" sm="6">
											<v-file-input v-model="attachment" accept=".csv" placeholder="Upload your csv file" prepend-icon="mdi-file-document" :show-size="1000">
												<template v-slot:selection="{ text }">
													<v-chip color="primary" dark label small>{{ text }}</v-chip>
												</template>
											</v-file-input>

											<div class="d-flex justify-end">
												<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
											</div>
										</v-col>
									</v-row>
								</v-form>
							</v-card-text>
						</v-card>
					</v-dialog>

					<v-card v-if="isShowAddLink || isShowEditLink">
						<v-icon title="close" @click="closeEditLink()" style="float: right" v-if="isShowEditLink">mdi-close</v-icon>
						<v-icon title="close" @click="closeAddLink()" style="float: right" v-if="isShowAddLink">mdi-close</v-icon>
						<v-card-title>
							<span>{{ menu }}</span>
							<v-divider class="mx-4" inset vertical></v-divider>
							<span>{{ entity.name }}</span>
						</v-card-title>
						<v-form v-model="valid" ref="formLink" @submit.prevent="update">
							<v-col>
								<v-select v-model="entity.menuLinkList[currentIndex].type" :items="externalLinkTypes" label="External Link Type" :rules="[(v) => !!v || 'External Link Type is required']" required></v-select>
								<v-switch v-model="entity.menuLinkList[currentIndex].status" :label="entity.menuLinkList[currentIndex].status ? 'Active' : 'Inactive'"></v-switch>
								<v-text-field class="input" v-model="entity.menuLinkList[currentIndex].title" label="Link Title" outlined :rules="[(v) => !!v || 'Link Title is required']" required></v-text-field>
								<span v-if="entity.menuLinkList[currentIndex].type == 'External Link' || entity.menuLinkList[currentIndex].type == 'Like Us'">
									<v-text-field class="input" v-model="entity.menuLinkList[currentIndex].url" label="Link Url" outlined :rules="[(v) => !!v || 'Link Url is required']" required></v-text-field>
								</span>
								<span v-if="entity.menuLinkList[currentIndex].type == 'External Link' || entity.menuLinkList[currentIndex].type == 'HTML Content'">
									<p>Open Link in</p>
									<v-radio-group v-model="entity.menuLinkList[currentIndex].openLinkOption" required>
										<v-radio label="New Tab" value="1"></v-radio>
										<v-radio label="Current Tab" value="2"></v-radio>
									</v-radio-group>
								</span>
								<div class="d-flex justify-end">
									<v-btn color="blue darken-1" text @click="closeEditLink()" v-if="isShowEditLink">Cancel</v-btn>
									<v-btn color="blue darken-1" text @click="closeAddLink()" v-if="isShowAddLink">Cancel</v-btn>
									<v-btn :disabled="!valid" color="blue darken-1" type="submit">Save</v-btn>
								</div>
							</v-col>
						</v-form>
					</v-card>
				</v-col>
			</v-row>

			<v-dialog v-model="isUpload" width="400">
				<v-card>
					<v-card-text>
						<v-file-input
							v-if="uploadType == 'bannerImage'"
							v-model="attachment1"
							label
							placeholder="Drop files here to upload"
							prepend-icon="mdi-attachment"
							accept="image/png, image/jpeg, image/jpg, video/mp4"
							:show-size="1000"
						></v-file-input>
						<v-file-input
							v-else
							v-model="attachment1"
							label
							placeholder="Drop files here to upload"
							prepend-icon="mdi-attachment"
							accept="application/pdf, video/mp4"
							:show-size="1000"
							hint="For video files it's recommended to use resolution of 1080 pixels."
						></v-file-input>
					</v-card-text>
					<v-card-actions>
						<v-btn v-if="uploadType == 'video' || uploadType == 'document'" @click="uploadType == 'video' ? upload('video') : upload('document')">Save</v-btn>
						<v-btn v-else @click="uploadType == 'bannerUrl' ? upload('bannerUrl') : upload('bannerImage')">Save</v-btn>
						<v-btn
							@click="
								attachment1 = null;
								isUpload = false;
								uploadType = null;
							"
							>Cancel</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title>Delete</v-card-title>
					<v-card-text>Are you sure you want to delete?</v-card-text>
					<v-card-actions>
						<v-btn
							color="primary"
							text
							@click="
								dialogDelete = false;
								isDeleteBooth = false;
							"
							>Close</v-btn
						>
						<v-btn color="primary" text @click="deleteBooth()" v-if="isDeleteBooth">Delete</v-btn>
						<v-btn color="primary" text @click="deleteBoothRep()" v-if="menu == 'Booth Rep' && !isDeleteBooth">Delete</v-btn>
						<v-btn color="primary" text @click="deleteExternalLink()" v-if="menu == 'External Links' && !isDeleteBooth">Delete</v-btn>
						<v-btn color="primary" text @click="deleteDocument()" v-if="menu == 'Document' && !isDeleteBooth">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-snackbar v-model="snackbar">
				{{ snackbarContent }}
				<template v-slot:action="{ attrs }">
					<v-btn color="red" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
				</template>
			</v-snackbar>
		</v-container>
	</div>
</template>


<style scoped>
.horizontal-line {
	width: 100%;
	border-top: 0px;
}
.scroll {
	overflow-y: auto;
}
.lyt-imgs {
	width: 1001px;
	margin: 0 auto 20px;
}
.lyt-imgs-cog {
	position: relative;
	height: 555px;
	border: 1px solid #e3e8ed;
	margin: 20px 0;
}
.banner-place .banner-sel {
	cursor: pointer;
	position: absolute;
	z-index: 8;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: #ccc;
	border: 1px solid #aaa;
}
.sort {
	margin-top: 18px;
	font-size: 14px;
}
</style>

<script>
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";

export default {
	props: ["experienceId"],
	components: {
		editor: Editor
	},
	data: () => ({
		baseLocation: axios.defaults.baseURL,
		valid: true,
		booths: [],
		selectedPerson: [],
		totalRows: 50,
		rowsPerPage: [5, 10, 20, 50],
		sortOption: ["None", "Id", "Booth Name"],
		filterStatusOption: ["All", "Active", "Inactive"],
		sortBy: "None",
		sortDir: "asc",
		sortDirOption: ["asc", "desc"],
		filterStatus: "All",
		pagination: {
			page: 1,
			total: 0,
			perPage: 5,
			visible: 3
		},
		isDialog: false,
		dialogDelete: false,
		isAddBooth: false,
		isShowAddBoothRep: false,
		isEditBoothRep: false,
		isShowAddLink: false,
		isShowEditLink: false,
		isUploadImage: false,
		isAddDocument: false,
		isAddProduct: false,
		sm: "2",
		mdform: "0",
		mdtable: "12",
		isShowForm: false,
		menu: null,
		itemToDelete: {},
		currentIndex: 0,
		boothList: [],
		documentList: [],
		productList: [],
		document: {
			status: false,
			type: null,
			url: null,
			filename: null,
			title: null,
			dataMap: {}
		},
		documentTypes: ["Select a Type", "Document", "Video"],
		externalLinkTypes: ["Select a Type", "External Link"],
		featureTypes: ["Select a Type", "Description", "Feature Tab"],
		boothRepList: [],
		boothRep: { dataMap: {} },
		boothFeatureList: [
			{
				tabTitle: "Description",
				status: true,
				icon: "mdi-information"
			},
			{
				tabTitle: "Documents",
				status: true,
				icon: "mdi-file-document"
			},
			{
				tabTitle: "Videos",
				status: true,
				icon: "mdi-play-circle-outline"
			},
			{
				tabTitle: "Links",
				status: true,
				icon: "mdi-link-variant"
			},
			{
				tabTitle: "Booth Reps",
				status: true,
				icon: "mdi-chat"
			},
			{
				tabTitle: "Products",
				status: true,
				icon: "mdi-cart-outline"
			}
		],
		entity: { dataMap: {}, bannerList: [] },
		attachment1: null,
		attachment2: null,
		attachment3: null,
		attachment: null,
		layout: { bannerList: [] },
		showSaveFeature: false,
		personList: [],
		items: [],
		isLoading: null,
		keyword: "",
		experienceUser: {},
		isDeleteBooth: false,
		logoType: true,
		bannerType: true,
		imageType: true,
		animatedVideoType: true,
		docType: true,
		structureList: [],
		editBannerUrl: false,
		origin: null,
		selectedLayoutId: null,
		selectedLayoutImage: null,
		bannerDataList: [],
		isUpload: false,
		uploadType: null,
		layoutList: [],
		snackbar: false,
		snackbarContent: null,
		ticketList: [],
		layoutTagFilter: [],
		layoutTagList: [],
		layoutAll: [],
		livePreview: false,
		showLibrary: true,
		showSaveFeatureLimit: false,
		layoutTagListFilter: [],
		boothFeatureLimitList: [
			{
				tabTitle: "Links",
				icon: "mdi-link-variant"
			},
			{
				tabTitle: "Documents",
				icon: "mdi-file-document"
			},
			{
				tabTitle: "Videos",
				icon: "mdi-play-circle-outline"
			},
			{
				tabTitle: "Booth Reps",
				icon: "mdi-chat"
			}
		],
		showAddBtnDoc: true,
		showAddInterests: false,
		interestList: []
	}),

	watch: {
		dialog(val) {
			val || this.close();
		}
	},

	mounted() {
		this.listBooth();
		this.listTicket();
		this.listLayoutTag();
		this.listInterest();
		this.origin = this.$window.location.origin;
	},

	methods: {
		listStructure() {
			axios.get("/system/structure/list?&experienceId=" + this.experienceId).then((response) => {
				this.structureList = response.data;
			});
		},
		listPersonByExperienceId() {
			axios
				.post("/system/booth/person/list", {
					experienceId: this.experienceId,
					keyword: this.keyword
				})
				.then((response) => {
					this.personList = response.data;
				});
		},
		listLayoutTag() {
			axios.get("/system/layout/tag/list").then((response) => {
				this.layoutTagList = response.data;
			});
		},
		listInterest(){
			axios
				.post("/system/interest/experience/list", {
					experienceId: this.experienceId
				})
				.then((response) => {
					this.interestList = response.data;
					})
				.catch(() => {});
		},
		filterLayout(isFirstCall) {
			axios
				.post("/system/layout/filter", {
					planFilter: [],
					tagFilter: this.layoutTagFilter,
					tenantPlanId: this.$store.state.principal.tenantPlanId
				})
				.then((response) => {
					this.layoutList = response.data;
					if (isFirstCall) {
						this.layoutAll = this.layoutList;
					}
				});
		},
		resetLayout() {
			this.layoutPlanFilter = [];
			this.layoutTagFilter = this.entity.boothDesignTagList;
			this.layoutList = this.layoutAll;
		},
		swapLine(a, b) {
			let vm = this;
			axios
				.post("/system/booth/swap", {
					entity1: vm.boothList[a],
					entity2: vm.boothList[b]
				})
				.then(() => {
					vm.listBooth();
				});
		},
		up(entity) {
			let vm = this;
			let index = vm.boothList.indexOf(entity);
			if (index > 0) {
				this.swapLine(index - 1, index);
			}
		},
		down(entity) {
			let vm = this;
			let index = vm.boothList.indexOf(entity);
			if (index + 1 < this.boothList.length) {
				this.swapLine(index, index + 1);
			}
		},
		addBooth() {
			this.isAddBooth = true;
			this.entity = {
				name: null,
				description: null,
				logo: null,
				contactName: null,
				contactEmail: null,
				status: false,
				menuLinkList: [],
				bannerList: [],
				dataMap: {}
			};
			this.entity.boothFeatureList = this.boothFeatureList;
		},
		listBooth() {
			let vm = this;
			axios.get("/system/booth/list?experienceId=" + this.experienceId).then((response) => {
				vm.boothList = response.data;
				vm.booths = vm.boothList;
				if (this.filterStatus == this.filterStatusOption[1]) {
					vm.booths = vm.booths.filter((x) => x.status);
				} else if (this.filterStatus == this.filterStatusOption[2]) {
					vm.booths = vm.booths.filter((x) => !x.status);
				}

				if (this.sortBy != this.sortOption[0]) {
					this.sortBooth();
				} else {
					this.onPageChange();
				}
			});
		},
		save() {
			axios
				.post("/system/booth/add", {
					entity: this.entity,
					experienceId: this.experienceId
				})
				.then(() => {
					this.isAddBooth = false;
					this.listBooth();
				});
		},
		edit(item, type) {
			this.entity = { dataMap: {}, boothFeatureLimitList: this.boothFeatureLimitList };
			this.menu = type;
			this.isShowForm = true;
			this.isAddBooth = false;
			this.isShowAddBoothRep = false;
			this.isEditBoothRep = false;
			this.isShowAddLink = false;
			this.isShowEditLink = false;
			this.isUploadImage = false;
			this.isAddDocument = false;
			this.isAddProduct = false;
			this.find(item.id);
			if (this.menu == "Upload Image") {
				this.mdform = "12";
				this.sm = "2";
				var video = document.getElementById("video");
				if (video != null) {
					video.load();
				}
			} else {
				this.mdtable = "6";
				this.mdform = "6";
				this.sm = "3";
			}
			if (this.menu == "Document") {
				this.listDocument(item.id);
			} else if (this.menu == "Booth Settings") {
				this.listStructure();
			}
		},
		update() {
			if (this.entity.menuLinkList != null) {
				let i = 1;
				this.entity.menuLinkList.forEach((menuLink) => {
					menuLink.index = i;
					i++;
				});
			}
			let formData = new FormData();
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
				this.entity.dataMap.bannerIndex = this.currentIndex;
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
				this.entity.dataMap.bannerIndex = this.currentIndex;
			}
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}
			formData.append("entity", JSON.stringify(this.entity));
			formData.append("interestUpdateFlag", this.showAddInterests);
			axios
				.post("/system/booth/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					if (this.menu == "Booth Settings") {
						this.close();
						this.listBooth();
						this.$refs.formEditBooth.reset();
						this.logoType = true;
					} else if (this.isShowAddLink) {
						this.closeAddLink();
						this.find(this.entity.id);
					} else if (this.isShowEditLink) {
						this.isShowEditLink = false;
						this.find(this.entity.id);
					} else if (this.menu == "Upload Image") {
						if (this.editBannerUrl) {
							this.find(this.entity.id);
						}
					} else if (this.isShowAddBoothRep) {
						this.closeBoothRep();
						this.find(this.entity.id);
					} else if (this.showSaveFeature) {
						this.showSaveFeature = false;
					}
				});
		},
		find(id) {
			axios.get("/system/booth/find?id=" + id).then((response) => {
				this.entity = response.data;
				this.entity.id = id;
				this.entity.allowTicketList = response.data.allowTicketList;
				this.entity.denyTicketList = response.data.denyTicketList;
				if (!this.entity.boothFeatureLimitList) {
					this.entity.boothFeatureLimitList = this.boothFeatureLimitList;
				}
				if (this.menu == "Booth Rep") {
					this.listBoothRep();
				} else if (this.menu == "Product") {
					this.listProduct();
				} else if (this.menu == "Upload Image") {
					if (this.entity.boothDesignTagList == null || this.entity.boothDesignTagList.length == 0) {
						this.layoutTagFilter = [];
						this.layoutTagListFilter = this.layoutTagList;
						this.listLayout();
					} else {
						this.layoutTagFilter = this.entity.boothDesignTagList;
						this.layoutTagListFilter = this.entity.boothDesignTagList;
						this.filterLayout(true);
					}

					if (this.entity.layoutId != null) {
						this.selectedLayoutId = this.entity.layoutId;
						this.showLibrary = false;
						this.getLayout(1);
					}
				} else if (this.menu == "Settings") {
					if (this.entity.boothFeatureLimitList == null) {
						this.entity.boothFeatureLimitList = this.boothFeatureLimitList;
					}
				} else if (this.menu == "Document") {
					this.checkLimitForDocumentAndVideo();
				} else if (this.menu == "Booth Settings"){
					if(this.entity.interestList.length > 0){
						this.showAddInterests = false;
					} else {
						this.showAddInterests = true;
					}
				}
			});
		},
		listDocument(id) {
			axios.get("/system/booth/document/list?boothId=" + id).then((response) => {
				this.documentList = response.data;
				this.checkLimitForDocumentAndVideo();
			});
		},
		findDocument(id) {
			axios.get("/system/booth/document?id=" + id).then((response) => {
				this.document = response.data;
			});
		},
		updatingDocument() {
			let formData = new FormData();

			formData.append("document", JSON.stringify(this.document));
			formData.append("experienceId", JSON.stringify(this.experienceId));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			axios
				.post("/system/booth/document/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.isAddDocument = false;
					this.$refs.formEdit.reset();
					this.listDocument(this.entity.id);
				});
		},
		cancelAddDocument() {
			this.isAddDocument = false;
			this.$refs.formEdit.reset();
		},
		updateDocument() {
			if (this.document.id) {
				this.updatingDocument();
			} else {
				this.saveDocument();
			}
		},
		saveDocument() {
			let formData = new FormData();

			formData.append("document", JSON.stringify(this.document));
			formData.append("experienceId", this.experienceId);
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			axios
				.post("/system/booth/document/add", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.isAddDocument = false;
					this.$refs.formEdit.reset();
					this.listDocument(this.entity.id);
				});
		},
		addDocument() {
			this.isAddDocument = true;
			this.document = {
				status: true,
				type: null,
				url: null,
				filename: null,
				title: null,
				dataMap: { 
					docType: true,
					openLinkOption: "2"
				}
			};
			this.document.boothId = this.entity.id;
		},
		updateBoothRep() {
			if (!this.isEditBoothRep) {
				var emailArray = this.keyword.trim().split("\n");
				axios
					.post("/system/booth/boothRep/save", {
						boothId: this.entity.id,
						experienceId: this.experienceId,
						email: emailArray
					})
					.then(() => {
						this.closeBoothRep();
					});
			} else {
				if (this.selectedPerson) {
					this.boothRep.experienceUserId = this.selectedPerson;
				}
				axios
					.post("/system/booth/boothRep/update", {
						entity: this.boothRep
					})
					.then(() => {
						this.closeBoothRep();
						this.isEditBoothRep = false;
					});
			}
		},
		listBoothRep() {
			axios.get("/system/booth/boothRep/list?&id=" + this.entity.id).then((response) => {
				this.boothRepList = response.data;
			});
		},
		addBoothRep() {
			this.isShowAddBoothRep = true;
			this.experienceUser = {};
		},
		addExternalLink() {
			this.isShowAddLink = true;
			let index = 0;
			if (this.entity.menuLinkList != null) {
				index = this.entity.menuLinkList.length;
			}
			this.currentIndex = index;
			this.entity.menuLinkList.push({
				status: true,
				title: null,
				url: null,
				openLinkOption: "1",
				isShowPopup: false,
				type: null
			});
		},
		editExternalLink(item) {
			this.isShowEditLink = true;
			this.currentIndex = this.entity.menuLinkList.indexOf(item);
		},
		editBoothRep(item) {
			this.isShowAddBoothRep = true;
			this.isEditBoothRep = true;
			this.experienceUser = {};
			this.getBoothRep(this.entity.id, item.id);
			this.selectedPerson = item.id;
		},
		getBoothRep(boothId, experienceUserId) {
			axios.get("/system/booth/boothRep?boothId=" + boothId + "&experienceUserId=" + experienceUserId).then((response) => {
				this.boothRep = response.data;
				this.getExperienceUser(experienceUserId);
			});
		},
		getExperienceUser(experienceUserId) {
			axios.get("/system/booth/boothRep/experienceUser?experienceUserId=" + experienceUserId).then((response) => {
				this.experienceUser = response.data;
			});
		},
		changeFeatureStatus(item) {
			let currentIndex = this.entity.boothFeatureList.indexOf(item);
			this.entity.boothFeatureList[currentIndex].status = item.status;
			this.showSaveFeature = true;
		},
		changeFeatureLimit(item) {
			let currentIndex = this.entity.boothFeatureLimitList.indexOf(item);
			this.entity.boothFeatureLimitList[currentIndex].limit = item.limit;
			this.showSaveFeatureLimit = true;
		},
		changeTag() {
			this.showSaveFeatureLimit = true;
		},
		editDocument(item) {
			this.findDocument(item.id);
			this.isAddDocument = true;
		},
		deleteBooth() {
			axios.get("/system/booth/delete?id=" + this.itemToDelete.id).then(() => {
				this.listBooth();
				this.isDeleteBooth = false;
				this.dialogDelete = false;
			});
			this.dialogDelete = !this.dialogDelete;
		},
		deleteDocument() {
			axios.get("/system/booth/document/delete?id=" + this.itemToDelete.id).then((response) => {
				this.document = response.data;
				this.listDocument(this.entity.id);
				this.dialogDelete = false;
			});
			this.dialogDelete = !this.dialogDelete;
		},
		deleteExternalLink() {
			this.entity.menuLinkList.splice(this.currentIndex, 1);
			this.update();
			this.dialogDelete = false;
		},
		deleteBoothRep() {
			var experienceUserId = this.itemToDelete.id;
			var boothId = this.entity.id;
			axios.get("/system/booth/boothRep/delete?experienceUserId=" + experienceUserId + "&boothId=" + boothId).then(() => {
				this.listBoothRep();
				this.dialogDelete = false;
			});
		},
		inputImageUrl(banner) {
			if (this.entity.bannerList.length <= 0) {
				this.entity.bannerList = this.layout.bannerList;
				this.currentIndex = 0;
			} else {
				this.currentIndex = this.entity.bannerList.indexOf(banner);
			}

			this.editBannerUrl = true;
			this.isDialog = true;
		},
		closeAddLink() {
			this.isShowAddLink = false;
			this.$refs.formLink.reset();
			this.entity.menuLinkList.splice(this.currentIndex, 1);
		},
		closeEditLink() {
			this.isShowEditLink = false;
			this.find(this.entity.id);
		},
		closeUploadImage() {
			this.isShowForm = false;
			this.mdtable = "12";
			this.mdform = "0";
			this.sm = "2";
			this.menu = null;
			this.isDialog = false;
			this.selectedLayoutId = null;
			this.bannerDataList = [];
			this.resetLayout();
			this.showLibrary = true;
		},
		closeBoothRep() {
			this.isShowAddBoothRep = false;
			this.isEditBoothRep = false;
			this.$refs.formBoothRep.reset();
			this.listBoothRep();
		},
		showDeleteDialog(item) {
			if (this.menu == "External Links" && !this.isShowAddLink && !this.isShowEditLink) {
				this.currentIndex = this.entity.menuLinkList.indexOf(item);
			}
			this.itemToDelete = item;
			this.dialogDelete = !this.dialogDelete;
		},
		cancel() {
			this.isShowForm = false;
			this.isShowAddLink = false;
			this.mdtable = "12";
			this.sm = "2";
		},
		close() {
			this.showAddInterests = false;
			this.showSaveFeature = false;
			this.isShowForm = false;
			this.mdtable = "12";
			this.mdform = "0";
			this.sm = "2";
		},
		findLayout(id) {
			axios.get("/system/booth/layout?id=" + id).then((response) => {
				this.layout = response.data;
			});
		},
		changeTotalRows() {
			this.pagination.page = 1;
			this.onPageChange();
		},
		onPageChange() {
			this.pagination.total = Math.ceil(this.booths.length / this.totalRows);
			let startIndex = (this.pagination.page - 1) * this.totalRows;
			let endIndex = startIndex + this.totalRows;
			this.boothList = this.booths.slice(startIndex, endIndex);
		},
		sortBooth() {
			if (this.sortBy == this.sortOption[2]) {
				if (this.sortDir == this.sortDirOption[0]) {
					this.booths.sort((a, b) => {
						if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
						return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0;
					});
				} else {
					this.booths.sort((a, b) => {
						if (a.name.toLowerCase() > b.name.toLowerCase()) return -1;
						return a.name.toLowerCase() < b.name.toLowerCase() ? 1 : 0;
					});
				}
				this.onPageChange();
			} else if (this.sortBy == this.sortOption[1]) {
				if (this.sortDir == this.sortDirOption[0]) {
					this.booths.sort(function (a, b) {
						if (b.id > a.id) {
							return -1;
						}
						if (b.id < a.id) {
							return 1;
						}
						return 0;
					});
				} else {
					this.booths.sort(function (a, b) {
						if (b.id < a.id) {
							return -1;
						}
						if (b.id > a.id) {
							return 1;
						}
						return 0;
					});
				}
				this.onPageChange();
			} else {
				this.listBooth();
			}
		},
		listProduct() {
			axios.get("/system/booth/product/list?boothId=" + this.entity.id).then((response) => {
				this.productList = response.data;
			});
		},
		uploadProduct() {
			let formData = new FormData();
			formData.append("boothId", this.entity.id);
			formData.append("experienceId", this.experienceId);
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}

			axios.post("/system/booth/product/upload", formData).then(() => {
				this.listProduct();
				this.isAddProduct = false;
			});
		},
		download(url) {
			window.open(this.baseLocation + url + "?boothId=" + this.entity.id, "_blanks");
		},
		copyLink(item) {
			this.$clipboard(this.origin + "/#/booth/setup/" + this.experienceId + "/" + this.$store.state.principal.tenantId + "/" + this.$store.state.principal.tenantPlanId + "/" + item.dataMap.boothSetupId);
			this.snackbar = true;
			this.snackbarContent = "Copied";
		},
		listLayout() {
			axios
				.post("/system/layout/membership/list", {
					tenantPlanId: this.$store.state.principal.tenantPlanId
				})
				.then((response) => {
					this.layoutList = response.data;
					// Check if small asset is exist and use it
					let vm = this;
					this.layoutList.map(obj => {
						vm.$root.isImageExist(vm.$root.smallAsset(obj.dataMap.value), function(status) {
							if (status) {
								obj.dataMap.value = vm.$root.smallAsset(obj.dataMap.value)
							}
						});
						return obj;
					});
					this.layoutAll = this.layoutList;
				});
		},
		selectBoothTemplate(item) {
			this.selectedLayoutId = item.id;
			this.showLibrary = false;
			this.bannerDataList = [];
			this.getLayout(0);
		},
		getLayout(bannerDataLength) {
			axios.get("/system/public/booth/layout?id=" + this.selectedLayoutId).then((response) => {
				let banner = response.data.bannerList;
				this.selectedLayoutImage = response.data.dataMap.value;
				if (bannerDataLength != 0) {
					this.bannerDataList = this.entity.bannerList;
				}

				if (this.bannerDataList.length > 0) {
					for (let i = 0; i < banner.length; i++) {
						if (banner[i].name) {
							this.bannerDataList[i].name = banner[i].name;
							this.bannerDataList[i].width = banner[i].coordinateList[2];
							this.bannerDataList[i].height = banner[i].coordinateList[3];
						}
						this.bannerDataList[i].coordinateList = banner[i].coordinateList;
						this.bannerDataList[i].skewX = banner[i].skewX;
						this.bannerDataList[i].skewY = banner[i].skewY;
					}
				} else if (this.bannerDataList.length < 1) {
					let i = 0;
					while (i < banner.length) {
						let bannerDataList = {
							sequence: i + 1,
							name: banner[i].name,
							bannerType: true,
							url: null,
							openLinkOption: "2",
							imageType: true,
							image: null,
							width: banner[i].coordinateList[2],
							height: banner[i].coordinateList[3],
							coordinateList: banner[i].coordinateList,
							skewX: banner[i].skewX,
							skewY: banner[i].skewY
						};
						this.bannerDataList.push(bannerDataList);
						i++;
					}
				}
			});
		},
		openUpload(uploadType, item) {
			if (uploadType == "bannerUrl" || uploadType == "bannerImage") {
				this.currentIndex = this.bannerDataList.indexOf(item);
			}
			this.uploadType = uploadType;
		},
		upload(type) {
			let formData = new FormData();
			formData.append("boothId", this.entity.id);
			formData.append("experienceId", this.experienceId);
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			axios.post("/system/booth/layout/upload", formData).then((response) => {
				let filename = response.data;
				if (type == "bannerUrl") {
					this.bannerDataList[this.currentIndex].url = filename;
				} else if (type == "bannerImage") {
					this.bannerDataList[this.currentIndex].image = filename;
				}
				this.attachment1 = null;
				this.isUpload = false;
				this.uploadType = null;
			});
		},
		saveLayout() {
			this.entity.layoutId = this.selectedLayoutId;
			this.entity.bannerList = this.bannerDataList;
			this.update();
		},
		listTicket() {
			axios
				.get("/system/ticket/list?experienceId=" + this.experienceId)
				.then((response) => {
					this.ticketList = response.data;
				})
				.catch(() => {});
		},
		numberChecking(item) {
			let number = "";
			for (var i = 0; i < item.limit.length; i++) {
				if (!isNaN(item.limit.charAt(i))) {
					number += item.limit.charAt(i);
				} else {
					break;
				}
			}
			number = number == "" ? null : number;
			let currentIndex = this.entity.boothFeatureLimitList.indexOf(item);
			this.entity.boothFeatureLimitList[currentIndex].limit = number;
		},
		checkLimitForDocumentAndVideo() {
			this.documentTypes = ["Select a Type"];
			if (this.entity.boothFeatureLimitList != null) {
				if (this.entity.boothFeatureLimitList[1].limit == null || this.getLengthPerType(this.documentList, "Document") < this.entity.boothFeatureLimitList[1].limit) {
					this.documentTypes.push("Document");
				}
				if (this.entity.boothFeatureLimitList[2].limit == null || this.getLengthPerType(this.documentList, "Video") < this.entity.boothFeatureLimitList[2].limit) {
					this.documentTypes.push("Video");
				}
			} else {
				this.documentTypes.push("Document");
				this.documentTypes.push("Video");
			}
			this.showAddBtnDoc = this.documentTypes.length == 1 ? false : true;
		},
		getLengthPerType(documentList, type) {
			var lenght = 0;
			for (let doc of documentList) {
				if (doc.type == type) {
					lenght++;
				}
			}
			return lenght;
		},
		checkLimitForBoothRep() {
			if (this.keyword.endsWith("\n")) {
				let split = this.keyword.split("\n");
				let limit = split.length + this.boothRepList.length - 1;
				if (limit >= this.entity.boothFeatureLimitList[3].limit) {
					let keyword = "";
					for (let i = 0; i < this.entity.boothFeatureLimitList[3].limit - this.boothRepList.length; i++) {
						keyword += i > 0 ? "\n" : "";
						keyword += split[i];
					}
					this.keyword = keyword + " ";
				}
			}
		}
	}
};
</script>